import * as _ from "lodash";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import {
    DefinitionApplicationInstance,
    DefinitionProduct,
    DefinitionJobTitleCategory,
    DefinitionApplicationGroup,
    DefinitionApplicationRole,
    DefinitionResourceType,
    DefinitionResourceTypeData,
    DefinitionTag
} from "./shared-definitions.types";
import { map } from "rxjs/operators";
import { ServerGatewayBase } from "@logex/framework/lg-application";
import { SharedConfigService } from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";

@Injectable({ providedIn: "root" })
export class SharedDefinitionsApiService extends ServerGatewayBase {
    protected _configService = inject(SharedConfigService);

    constructor() {
        super();

        this._fakeCache = false;
        const apiUrl = this._configService.applicationUrl;
        if (apiUrl != null) {
            this._setBaseUrl(`${apiUrl}api/v1/definition/`);
        } else {
            console.error("Cannot set App API url based on configuration.");
        }
    }

    getApplicationInstance(): Observable<_.Dictionary<DefinitionApplicationInstance>> {
        return this._get<DefinitionApplicationInstance[]>(`applicationInstances`).pipe(
            map((res: DefinitionApplicationInstance[]) => _.keyBy(res, item => item.code))
        );
    }

    getApplicationGroup(): Observable<_.Dictionary<DefinitionApplicationGroup>> {
        return this._get<DefinitionApplicationGroup[]>(`applicationGroups`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getApplicationRole(): Observable<_.Dictionary<DefinitionApplicationRole>> {
        return this._get<DefinitionApplicationRole[]>(`applicationRoles`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getJobTitleCategory(): Observable<_.Dictionary<DefinitionJobTitleCategory>> {
        return this._get<DefinitionJobTitleCategory[]>(`jobTitleCategories`).pipe(
            map(res => _.keyBy(res, item => item.id))
        );
    }

    getProduct(): Observable<_.Dictionary<DefinitionProduct>> {
        return this._get<DefinitionProduct[]>(`products`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getResourceType(): Observable<_.Dictionary<DefinitionResourceType>> {
        return this._get<DefinitionResourceTypeData[]>(`resourceTypes`).pipe(
            map(res => {
                const types = res.map(type => ({
                    id: type.id,
                    name: type.displayName,
                    code: type.code
                }));
                return _.keyBy(types, item => item.code);
            })
        );
    }

    getTags(): Observable<_.Dictionary<DefinitionTag>> {
        return this._get<DefinitionTag[]>(`tags`).pipe(map(res => _.keyBy(res, item => item.code)));
    }
}
